module.exports = __webpack_public_path__ + "static/img/新闻详情banner.325299e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/新闻详情banner.png
// module id = wiBj
// module chunks = 0